import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import PrivateRoute from './components/PrivateRoute';

// Admin Manager
import AdminLayout from './layouts/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AddShop from './pages/admin/settings/AddShop';
import AddWarehouse from './pages/admin/settings/AddWarehouse';
import AddUser from './pages/admin/settings/AddUser';
import AddSparepart from './pages/admin/sparepart/AddSparepart';
import SparepartControl from './pages/admin/sparepart/SparepartControl';
import SparepartAudit from './pages/admin/sparepart/SparepartAudit';
import AddAccount from './pages/admin/settings/AddAccount';
import SalesReport from './pages/admin/reports/SalesReport';
import InventoryReport from './pages/admin/reports/InventoryReport';
import CustomerReport from './pages/admin/reports/CustomerReport';
import CreditReport from './pages/admin/credit/CreditReport';
import ShowCredit from './pages/admin/credit/ShowCredit';
import CustomerNotification from './pages/admin/reports/CustomerNotification';
import CustomerManagement from './pages/admin/customers/CustomerManagement';
// Inventory Manager
import InventoryLayout from './layouts/InventoryLayout';
import InventoryDashboard from './pages/inventory/InventoryDashboard';
import InventoryList from './pages/inventory/InventoryList';
import InventoryLog from './pages/inventory/InventoryLog';
import SearchAndSendSparePart from './pages/inventory/SearchAndSendSparePart';
import TransferSpareParts from './pages/inventory/TransferSpareParts';
import AcceptSparePart from './pages/inventory/AcceptSparePart';
import AddToInventory from './pages/admin/inventory/AddToInventory';
import SalesList from './pages/admin/inventory/SalesList';
import PurchaseOrder from './pages/admin/purchase/PurchaseOrder';
import CreatePurchaseOrder from './pages/admin/purchase/CreatePurchaseOrder';
import BulkCreatePurchaseOrder from './pages/admin/purchase/BulkCreatePurchaseOrder';
import ViewPurchaseOrder from './pages/admin/purchase/ViewPurchaseOrder';
import LowStock from './pages/admin/purchase/LowStock';
// Sales Manager
import SalesManagerLayout from './layouts/SalesManagerLayout';
import SalesManagerDashboard from './pages/sales/SalesManagerDashboard';
import NewSale from './pages/sales/NewSale';
import NewBuyAndSell from './pages/sales/NewBuyAndSell';
import Proforma from './pages/sales/Proforma';
import AllProformaList from './pages/sales/AllProformaList';
import SalesLog from './pages/sales/SalesLog';
import TransferLog from './pages/sales/TransferLog';
import CollectCredit from './pages/sales/CollectCredit';
import CustomerNotificationSales from './pages/sales/CustomerNotification';
function App() {
   return (
    
    <Router>
      <Routes>
        {/* ====================== PUBLIC ROUTE ====================== */}
        <Route path="/login" element={<Login />} />

        {/* ====================== ADMIN ROUTES ====================== */}
        <Route
          path="/admin/*"
          element={
            <PrivateRoute allowedRoles={['admin', 'systemadmin', 'marketing', 'finance']}>
              <AdminLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="create-shop" element={<AddShop />} />
          <Route path="create-warehouse" element={<AddWarehouse />} />
          <Route path='create-bankaccount' element={<AddAccount />} />
          <Route path="create-user" element={<AddUser />} />
              <Route path="log" element={<InventoryLog />} />
          <Route path="add-sparepart" element={<AddSparepart />} />
           <Route path="sparepart-control" element={<SparepartControl />} />
           <Route path="sparepart-audit" element={<SparepartAudit />} />
           <Route path="inventorylist" element={<InventoryList />} />
           <Route path="addtoinventory" element={<AddToInventory />} />
           <Route path="sales-list" element={<SalesList />} />
            <Route path="purchase-order" element={<PurchaseOrder />} />
            <Route path="purchase-order/create" element={<CreatePurchaseOrder />} />
            <Route path="purchase-order/bulk-create" element={<BulkCreatePurchaseOrder />} />
            <Route path="purchase-order/view/:id" element={<ViewPurchaseOrder />} />
            <Route path="low-stock" element={<LowStock />} />
            <Route path="sales-report" element={<SalesReport />} />
               <Route path="inventory-report" element={<InventoryReport />} />
                 <Route path="customer-report" element={<CustomerReport />} />
                 <Route path="show-credit" element={<ShowCredit />} />
                 <Route path="credit-report" element={<CreditReport/>} />
                 <Route path="customer-notification" element={<CustomerNotification />} />
                    <Route path="customer-management" element={<CustomerManagement />} />
        </Route>

        {/* ====================== INVENTORY ROUTES ====================== */}
        <Route
          path="/inventory/*"
          element={
            <PrivateRoute allowedRoles={['inventorymanager', 'admin']}>
              <InventoryLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<InventoryDashboard />} />
          <Route path="dashboard" element={<InventoryDashboard />} />
          <Route path="list" element={<InventoryList />} />
          <Route path="log" element={<InventoryLog />} />
          <Route path="search" element={<SearchAndSendSparePart />} />
          <Route path="transfer" element={<TransferSpareParts />} />
          <Route path="accept" element={<AcceptSparePart />} />
          <Route path="send" element={<SearchAndSendSparePart />} />
        </Route>

        {/* ====================== SALES ROUTES ====================== */}
        <Route
          path="/sales/*"
          element={
            <PrivateRoute allowedRoles={['salesmanager', 'admin']}>
              <SalesManagerLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<SalesManagerDashboard />} />
          <Route path="dashboard" element={<SalesManagerDashboard />} />
          <Route path="new-sale" element={<NewSale />} />
          <Route path="new-buyandsale" element={<NewBuyAndSell />} />
          <Route path="proforma" element={<Proforma />} />
            <Route path="allproforma" element={<AllProformaList />} />
             <Route path="collect-credit" element={<CollectCredit />} />
          <Route path="list" element={<InventoryList />} />
          <Route path="search" element={<SearchAndSendSparePart />} />
          <Route path="transfer" element={<TransferSpareParts />} />
          <Route path="accept" element={<AcceptSparePart />} />
          <Route path="sparetransfer-log" element={<TransferLog />} />
          <Route path="sales-attachement-log" element={<SalesLog />} />
           <Route path="customer-notification" element={<CustomerNotificationSales />} />
        
        </Route>

         {/* ====================== CATCH-ALL ====================== */}
         <Route path="*" element={<Navigate to="/login" replace />} />
       </Routes>

    </Router>
  );
}

export default App;
